import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';

const RecentMatches = ({ matches }) => {
  const navigate = useNavigate();
  return (
    <div className="bg-white rounded-lg shadow-md p-4 sm:p-6">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 sm:gap-0 mb-4">
        <h2 className="text-xl font-semibold text-green-800">Recent Matches</h2>
        <NavLink to="/new-match" className="bg-green-500 hover:bg-green-600 text-white font-semibold py-2 px-4 rounded-md transition duration-300 w-full sm:w-auto text-center">+ Add Match</NavLink>
      </div>
      <div className="space-y-4">
        {matches.slice(0, 5).map((match, index) => (
          <div
            key={index}
            className="flex flex-col sm:grid sm:grid-cols-3 gap-2 sm:gap-0 sm:items-center p-4 rounded-lg bg-gray-50 shadow-sm cursor-pointer hover:bg-gray-100 transition duration-150 ease-in-out"
            onClick={() => navigate(`/match-details/${match.match_id}`)}
          >
            <div className="font-semibold flex items-center gap-2">
              <span className={`px-3 py-1 rounded-full text-xs font-bold text-white ${match.result.toLowerCase() === 'me' ? 'bg-green-500' : 'bg-red-500'}`}>{match.result}</span>
              <span className="truncate">vs {match.opponent}</span>
            </div>
            <div className="text-gray-600 text-sm order-3 sm:order-none">
              <span className="truncate">{match.surface} • {match.date}</span>
            </div>
            <div className="font-semibold sm:text-right">
              <span>{match.score}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RecentMatches;


